/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

/**
 * Labels the property editor used to save as amenity values, mapped to the
 * backend token each one stands for.
 *
 * Until 2026-10-29 the editor offered display text ("Salão de Festas") while
 * everything else (backend vocabulary, importer, crawler) wrote tokens
 * ("Salao_de_festas"), so a listing could hold either. Labels that read the
 * same as their token ("Piscina", "Sauna") need no entry.
 */
const LEGACY_AMENITY_LABELS: Record<string, string> = {
  'Quadra': 'Quadra_poliesportiva', // i18n-exempt: legacy backend amenity token map, not UI text
  'Salão de Festas': 'Salao_de_festas', // i18n-exempt: legacy backend amenity token map, not UI text
  'Pet Place': 'Espaco_pet', // i18n-exempt: legacy backend amenity token map, not UI text
  'Espaço Gourmet': 'Espaco_gourmet', // i18n-exempt: legacy backend amenity token map, not UI text
  'Ar Condicionado': 'Ar_condicionado', // i18n-exempt: legacy backend amenity token map, not UI text
  'Aquecimento Central': 'Aquecimento_central', // i18n-exempt: legacy backend amenity token map, not UI text
  'Área de Serviço': 'Area_de_servico', // i18n-exempt: legacy backend amenity token map, not UI text
  'Depósito': 'Deposito', // i18n-exempt: legacy backend amenity token map, not UI text
  'Bicicletário': 'Bicicletario', // i18n-exempt: legacy backend amenity token map, not UI text
  'Portaria 24h': 'Seguranca_24h', // i18n-exempt: legacy backend amenity token map, not UI text
  'Câmeras': 'Cameras_de_seguranca', // i18n-exempt: legacy backend amenity token map, not UI text
  'Cerca Elétrica': 'Cerca_eletrica', // i18n-exempt: legacy backend amenity token map, not UI text
  'Controle de Acesso': 'Controle_de_acesso', // i18n-exempt: legacy backend amenity token map, not UI text
  'Ronda Noturna': 'Ronda_noturna', // i18n-exempt: legacy backend amenity token map, not UI text
  'Guarita Blindada': 'Guarita_blindada', // i18n-exempt: legacy backend amenity token map, not UI text
};

/**
 * Rewrites editor-era labels in an amenity list to their tokens, dropping the
 * duplicate a listing gets when it holds both spellings of one amenity.
 *
 * @param values - Amenity values as stored on the property.
 * @returns The same values with legacy labels replaced by tokens.
 */
export function normalizeLegacyAmenities(values: readonly string[]): string[] {
  return [...new Set(values.map((value) => LEGACY_AMENITY_LABELS[value] ?? value))];
}
